/* import __COLOCATED_TEMPLATE__ from './layout-wrapper.hbs'; */
/* RESPONSIBLE TEAM: team-actions */
import templateOnlyComponent from '@ember/component/template-only';

export type PreviewRenderMode = 'right-slot' | 'none';

interface Args {
  headerTitle?: string;
  layout?: string;
  renderMode?: PreviewRenderMode;
  isOnProceduresPage?: boolean;
}

interface Signature {
  Args: Args;
  Blocks: {
    actions: [];
    additionalInfo: [];
    content: [];
  };
  Element: HTMLElement;
}

const LayoutWrapper = templateOnlyComponent<Signature>();
export default LayoutWrapper;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::Preview::LayoutWrapper': typeof LayoutWrapper;
    'workflows/preview/layout-wrapper': typeof LayoutWrapper;
  }
}
